/**
 * SB2-W-16 — TanStack Query keys for the projects feature.
 */
import type { ListProjectsParams } from "./types.js";

export const projectsKeys = {
  all: ["projects"] as const,
  lists: () => [...projectsKeys.all, "list"] as const,
  list: (params: ListProjectsParams) =>
    [...projectsKeys.lists(), params] as const,
  /** PM-D38 — single-project detail (`GET /projects/{projectId}`). */
  detail: (projectId: string) =>
    [...projectsKeys.all, "detail", projectId] as const,
  /** FB-14 — a project's turbines for the detail map
   *  (`GET /projects/{projectId}/turbines`). */
  turbines: (projectId: string) =>
    [...projectsKeys.all, "turbines", projectId] as const,
  facets: () => [...projectsKeys.all, "facets"] as const,
  customerFacet: () => [...projectsKeys.facets(), "customers"] as const,
  contractorFacet: () => [...projectsKeys.facets(), "contractors"] as const,
};
